var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.41 0.129883L0 1.53988L4.39 5.92988L6.6 10.5899L3.62 15.9999H14.46L15.84 17.3799C15.34 17.7399 15.01 18.3299 15.01 18.9999C15.01 20.0999 15.9 20.9999 17 20.9999C17.67 20.9999 18.26 20.6699 18.62 20.1599L21.46 22.9999L22.87 21.5899L1.41 0.129883ZM7 13.9999L8.1 11.9999H10.46L12.46 13.9999H7ZM16.05 11.9399H16.78L21.7 2.99988H7.12L16.05 11.9399ZM7 16.9999C5.9 16.9999 5.01 17.8999 5.01 18.9999C5.01 20.0999 5.9 20.9999 7 20.9999C8.1 20.9999 9 20.0999 9 18.9999C9 17.8999 8.1 16.9999 7 16.9999Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartEmpty);
export default __webpack_public_path__ + "static/media/cart-empty.c1ad0546b7e490812621f36598871d30.svg";
export { ForwardRef as ReactComponent };